<template lang="pug">
  div(
    class="e-chip-status text-12px"
    :style="styles"
  ) {{ status.text }}
</template>

<script>
export default {
  name: 'EChipStatus',
  props: {
    status: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    styles() {
      return {
        color: this.status.color,
        backgroundColor: this.status.backgroundColor
      }
    }
  }
}
</script>

<style scoped lang="scss">
.e-chip-status {
  padding: 4px 8px;
  border-radius: 20px;
}
</style>
